module.exports = __webpack_public_path__ + "img/file-document-edit-outline.0df7dba5.png";